import React, { useEffect, useState } from "react";
import axios from "axios";
import './ExpensesDetailsAdd.css';
import ManagerSidebar from '../components/Sidebar/ManagerSidebar';

const ExpensesDetailsAdd = () => {
  const API_URL = "https://ikaze-thouse-backend.vercel.app/api/expenses-details";

  const [expenses, setExpenses] = useState([]);
  const [description, setDescription] = useState("");
  const [category, setCategory] = useState("");
  const [editingId, setEditingId] = useState(null);

  const fetchExpenses = async () => {
    try {
      const res = await axios.get(API_URL);
      setExpenses(res.data.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchExpenses();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = { Description: description, Category: category };
      if (editingId) {
        await axios.put(`${API_URL}/${editingId}`, payload);
      } else {
        await axios.post(API_URL, payload);
      }
      setDescription("");
      setCategory("");
      setEditingId(null);
      fetchExpenses();
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setDescription(item.description);
    setCategory(item.category);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this expense?")) {
      try {
        await axios.delete(`${API_URL}/${id}`);
        fetchExpenses();
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div className="dashboard-container">
      <ManagerSidebar />
      <div className="dashboard-wrapper">
        
        {/* Top Header Section */}
        <header className="dashboard-header">
          <h1 className="page-title">Expenses Management</h1>
          <p className="page-subtitle">Track, monitor, and categorize house expenditures seamlessly.</p>
        </header>

        {/* Vertical Stack Content Layout */}
        <div className="dashboard-stack">
          
          {/* Top Row: Form Section */}
          <div className="card form-container">
            <h3 className="card-title">{editingId ? "Modify Expense" : "Add New Expense"}</h3>
            <form onSubmit={handleSubmit} className="expense-inline-form">
              <div className="input-group">
                <label>Description</label>
                <input
                  type="text"
                  placeholder="e.g., Internet bill"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  required
                  className="form-input"
                />
              </div>

              <div className="input-group">
                <label>Category</label>
                <input
                  type="text"
                  placeholder="e.g., Utilities"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  required
                  className="form-input"
                />
              </div>

              <div className="form-actions">
                <button type="submit" className={`submit-btn ${editingId ? 'update-state' : ''}`}>
                  {editingId ? "Update Transaction" : "Log Expense"}
                </button>
                
                {editingId && (
                  <button 
                    type="button" 
                    className="cancel-btn" 
                    onClick={() => { setEditingId(null); setDescription(""); setCategory(""); }}
                  >
                    Cancel
                  </button>
                )}
              </div>
            </form>
          </div>

          {/* Bottom Row: Data View Table */}
          <div className="card table-container">
            <div className="table-header-row">
              <h3 className="card-title">All Logs</h3>
              <span className="count-badge">{expenses.length} Records</span>
            </div>
            
            <div className="table-responsive">
              <table className="expense-table">
                <thead>
                  <tr>
                    <th>ID</th>
                    <th>Description</th>
                    <th>Category</th>
                    <th className="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {expenses.length === 0 ? (
                    <tr>
                      <td colSpan="4" className="empty-state">No expense logs found.</td>
                    </tr>
                  ) : (
                    expenses.map((item) => (
                      <tr key={item.id}>
                        <td><span className="id-badge">#{item.id}</span></td>
                        <td className="font-medium">{item.description}</td>
                        <td><span className="category-tag">{item.category}</span></td>
                        <td className="text-right">
                          <div className="action-cluster">
                            <button onClick={() => handleEdit(item)} className="btn-icon edit-variant" title="Edit">
                              Edit
                            </button>
                            <button onClick={() => handleDelete(item.id)} className="btn-icon delete-variant" title="Delete">
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ExpensesDetailsAdd;